import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import {RouterProvider} from "react-router-dom";
import router from "./router";
import {ContextProvider} from "./contexts/ContextProvider";
import {QueryClientProvider} from "react-query";
import { queryClient } from './api/queryClient';
import {I18nextProvider} from "react-i18next";
import i18n from './i18n';
import { setLocaleApplier } from './contexts/localeBridge';
import {PostHogProvider} from 'posthog-js/react';
import posthog from './lib/posthog';
import PostHogIdentifier from './components/analytics/PostHogIdentifier';
import GlobalToast from './components/feedBack/GlobalToast';

// L'app WEB sait changer de langue ; l'app mobile non (#73 : ses libellés sont
// écrits en français directement). C'est donc le POINT D'ENTRÉE qui déclare la
// capacité, plutôt que le module partagé qui l'importe — sans quoi l'app mobile
// hérite des 24 espaces de noms d'i18next, soit 608 Ko en 24 requêtes pour des
// écrans qu'elle ne porte pas (#99).
setLocaleApplier((locale) => {
    if (i18n.language !== locale) void i18n.changeLanguage(locale);
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <PostHogProvider client={posthog}>
            <I18nextProvider i18n={i18n}>
                <QueryClientProvider client={queryClient}>
                    <ContextProvider>
                        <PostHogIdentifier />
                        <RouterProvider router={router}/>
                        <GlobalToast />
                    </ContextProvider>
                </QueryClientProvider>
            </I18nextProvider>
        </PostHogProvider>
    </React.StrictMode>
);
